import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import horizontalLoop from "../js_modules/_horizontal-loop.mjs";
import initTestimonialSlider from "../js_modules/_testimonial-slider.mjs";
import expertiseShader from "../js_modules/_expertise-shader.mjs";
import initServiceFourHero from "../js_modules/_service-four-hero.mjs";

gsap.registerPlugin(ScrollToPlugin);

const hero_list = document.querySelector(".services-hero__list");
if (hero_list) {
  hero_list.querySelectorAll("a").forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      gsap.to(window, {
        scrollTo: { y: anchor.getAttribute("href"), offsetY: 100 },
        duration: 1,
      });
    });
  });
}

const scrolling_projects = gsap.utils.toArray(
  ".services-hero__scrolling-project",
);
if (scrolling_projects && scrolling_projects.length > 0) {
  horizontalLoop(scrolling_projects, { speed: 0.8, repeat: -1 });
}

initTestimonialSlider();

const faq_questions = document.querySelectorAll(".faq-questions__question");

if (faq_questions) {
  faq_questions.forEach((question) => {
    const trigger = question.querySelector(".faq-questions__question-top");
    const answer_outer = question.querySelector(
      ".faq-questions__question-answer-outer",
    );
    if (trigger) {
      trigger.addEventListener("click", () => {
        if (!trigger.classList.contains("open")) {
          trigger.classList.add("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: "auto", duration: 0.5 });
          }
        } else {
          trigger.classList.remove("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: 0, duration: 0.5 });
          }
        }
      });
    }
  });
}

expertiseShader();
initServiceFourHero();
